import React from "react";
import Logo from "../../images/jslogo.png";
import { json, Link, NavLink, useParams, useNavigate } from "react-router-dom";

export default function Footer() {
  return (
    <div>
      <section
        class="py-5 sm:py-16 bg-amber-950"
        style={{ fontFamily: "Abhaya Libre" }}
      >
        <div class="container px-4 mx-auto">
          <div class="max-w-7xl mx-auto">
            <div class="md:pb-8 mb-15 border-b border-white items-center">
              <div class="flex flex-wrap -mx-4 items-center">
                <div class="w-full lg:w-1/2 px-4 md:mb-4 lg:mb-0">
                  <a class="inline-block" href="#">
                    <img class="h-16" src={Logo} alt="" />
                  </a>
                </div>

                <div class="w-full lg:w-1/2 px-4">
                  <div class="sm:flex -mb-4 items-center lg:justify-end">
                    <p className="text-white md:pb-4 pr-4 text-xl font-medium">
                      Follow Us On
                    </p>
                    <a
                      class="inline-block mr-2 pb-5  rounded-md p-1"
                      href="https://www.facebook.com/thejewelleryshow/?epa=SEARCH_BOX"
                      target="_blank"
                    >
                      <svg
                        width="50px"
                        height="50px"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="24" cy="24" r="20" fill="white" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M29.315 16.9578C28.6917 16.8331 27.8498 16.74 27.3204 16.74C25.8867 16.74 25.7936 17.3633 25.7936 18.3607V20.1361H29.3774L29.065 23.8137H25.7936V35H21.3063V23.8137H19V20.1361H21.3063V17.8613C21.3063 14.7453 22.7708 13 26.4477 13C27.7252 13 28.6602 13.187 29.8753 13.4363L29.315 16.9578Z"
                          fill="maroon"
                        />
                      </svg>
                    </a>
                    <a
                      class="inline-block mr-2 pb-5  rounded-md p-1"
                      href="https://www.instagram.com/thejewelleryshow/?hl=en"
                      target="_blank"
                    >
                      <svg
                        width="50px"
                        height="50px"
                        viewBox="0 0 48 48"
                        fill="red"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="24" cy="24" r="20" fill="white" />
                        <path
                          d="M24 14.1622C27.2041 14.1622 27.5837 14.1744 28.849 14.2321C30.019 14.2855 30.6544 14.481 31.0773 14.6453C31.6374 14.863 32.0371 15.123 32.457 15.5429C32.877 15.9629 33.137 16.3626 33.3547 16.9227C33.519 17.3456 33.7145 17.981 33.7679 19.1509C33.8256 20.4163 33.8378 20.7958 33.8378 23.9999C33.8378 27.2041 33.8256 27.5836 33.7679 28.849C33.7145 30.019 33.519 30.6543 33.3547 31.0772C33.137 31.6373 32.877 32.0371 32.4571 32.457C32.0371 32.8769 31.6374 33.1369 31.0773 33.3546C30.6544 33.519 30.019 33.7144 28.849 33.7678C27.5839 33.8255 27.2044 33.8378 24 33.8378C20.7956 33.8378 20.4162 33.8255 19.151 33.7678C17.981 33.7144 17.3456 33.519 16.9227 33.3546C16.3626 33.1369 15.9629 32.8769 15.543 32.457C15.1231 32.0371 14.863 31.6373 14.6453 31.0772C14.481 30.6543 14.2855 30.019 14.2321 28.849C14.1744 27.5836 14.1622 27.2041 14.1622 23.9999C14.1622 20.7958 14.1744 20.4163 14.2321 19.1509C14.2855 17.981 14.481 17.3456 14.6453 16.9227C14.863 16.3626 15.123 15.9629 15.543 15.543C15.9629 15.123 16.3626 14.863 16.9227 14.6453C17.3456 14.481 17.981 14.2855 19.151 14.2321C20.4163 14.1744 20.7959 14.1622 24 14.1622ZM24 12C20.741 12 20.3323 12.0138 19.0524 12.0722C17.7752 12.1305 16.9028 12.3333 16.1395 12.63C15.3504 12.9366 14.6812 13.3469 14.0141 14.0141C13.3469 14.6812 12.9366 15.3504 12.63 16.1395C12.3333 16.9028 12.1305 17.7751 12.0722 19.0524C12.0138 20.3323 12 20.741 12 23.9999C12 27.259 12.0138 27.6676 12.0722 28.9475C12.1305 30.2248 12.3333 31.0971 12.63 31.8604C12.9366 32.6495 13.3469 33.3187 14.0141 33.9859C14.6812 34.653 15.3504 35.0633 16.1395 35.3699C16.9028 35.6666 17.7752 35.8694 19.0524 35.9277C20.3323 35.9861 20.741 35.9999 24 35.9999C27.259 35.9999 27.6677 35.9861 28.9476 35.9277C30.2248 35.8694 31.0972 35.6666 31.8605 35.3699C32.6496 35.0633 33.3188 34.653 33.9859 33.9859C34.653 33.3187 35.0634 32.6495 35.37 31.8604C35.6667 31.0971 35.8695 30.2248 35.9278 28.9475C35.9862 27.6676 36 27.259 36 23.9999C36 20.741 35.9862 20.3323 35.9278 19.0524C35.8695 17.7751 35.6667 16.9028 35.37 16.1395C35.0634 15.3504 34.653 14.6812 33.9859 14.0141C33.3188 13.3469 32.6496 12.9366 31.8605 12.63C31.0972 12.3333 30.2248 12.1305 28.9476 12.0722C27.6677 12.0138 27.259 12 24 12Z"
                          fill="maroon"
                        />
                        <path
                          d="M24.0059 17.8433C20.6026 17.8433 17.8438 20.6021 17.8438 24.0054C17.8438 27.4087 20.6026 30.1675 24.0059 30.1675C27.4092 30.1675 30.1681 27.4087 30.1681 24.0054C30.1681 20.6021 27.4092 17.8433 24.0059 17.8433ZM24.0059 28.0054C21.7968 28.0054 20.0059 26.2145 20.0059 24.0054C20.0059 21.7963 21.7968 20.0054 24.0059 20.0054C26.2151 20.0054 28.0059 21.7963 28.0059 24.0054C28.0059 26.2145 26.2151 28.0054 24.0059 28.0054Z"
                          fill="maroon"
                        />
                        <path
                          d="M31.8507 17.5963C31.8507 18.3915 31.206 19.0363 30.4107 19.0363C29.6154 19.0363 28.9707 18.3915 28.9707 17.5963C28.9707 16.801 29.6154 16.1562 30.4107 16.1562C31.206 16.1562 31.8507 16.801 31.8507 17.5963Z"
                          fill="maroon"
                        />
                      </svg>
                    </a>
                    <a
                      class="inline-block mr-2 pb-5  rounded-md p-1"
                      href="https://www.youtube.com/channel/UCitxmJg1sCEsppGlPas9faA"
                      target="_blank"
                    >
                      <svg
                        width="50px"
                        height="50px"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="24" cy="24" r="20" fill="white" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M35.3005 16.3781C35.6996 16.7772 35.9872 17.2739 36.1346 17.8187C36.9835 21.2357 36.7873 26.6324 36.1511 30.1813C36.0037 30.7261 35.7161 31.2228 35.317 31.6219C34.9179 32.021 34.4212 32.3086 33.8764 32.456C31.8819 33 23.8544 33 23.8544 33C23.8544 33 15.8269 33 13.8324 32.456C13.2876 32.3086 12.7909 32.021 12.3918 31.6219C11.9927 31.2228 11.7051 30.7261 11.5577 30.1813C10.7038 26.7791 10.9379 21.3791 11.5412 17.8352C11.6886 17.2903 11.9762 16.7936 12.3753 16.3945C12.7744 15.9954 13.2711 15.7079 13.8159 15.5604C15.8104 15.0165 23.8379 15 23.8379 15C23.8379 15 31.8654 15 33.8599 15.544C34.4047 15.6914 34.9014 15.979 35.3005 16.3781ZM27.9423 24L21.283 27.8571V20.1428L27.9423 24Z"
                          fill="maroon"
                        />
                      </svg>{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap pt-4 md:pt-12 lg:-mx-6 items-center justify-center">
              <div class="px-6 mb-3 md:mb-5">
                <a
                  class="inline-block text-gray-300 hover:text-gray-200 text-lg"
                  href="/"
                >
                  Home
                </a>
              </div>
              <div class="px-6 mb-3 md:mb-5">
                <a
                  class="inline-block text-gray-300 hover:text-gray-200 text-lg"
                  href="/upcomingshow"
                >
                  Upcoming Events
                </a>
              </div>
              <div class="px-6 mb-3 md:mb-5">
                <a
                  class="inline-block text-gray-300 hover:text-gray-200 text-lg"
                  href="/gallery"
                >
                  Gallery
                </a>
              </div>
              <div class="px-6 mb-3 md:mb-5">
                <a
                  class="inline-block text-gray-300 hover:text-gray-200 text-lg"
                  href="/blogs"
                >
                  Blogs
                </a>
              </div>

              <div class="px-6 mb-3 md:mb-5">
                <a
                  class="inline-block text-gray-300 hover:text-gray-200 text-lg"
                  href="/contact"
                >
                  Contact
                </a>
              </div>
            </div>
            <div class="mt-15 text-center text-xl">
              <span class=" text-orange-300">
            Golden Creeper Enterprises
                <br />
                No. 31 , 1st Cross , C Block , Annapoorneshwari Nagar , RHCS
Layout , Nagarbhavi 2nd Stage , Bengaluru (Bangalore) Urban ,<br/>
        +91 9900308217  <span className="ml-4">+91 9740777499</span>
              </span>
              <p className="mt-8 text-white text-sm" >© 2025 GOLDEN CREEPER ENTERPRISES</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
